import { Fragment } from "react"
import { Tab } from "@headlessui/react"
import { CloudArrowDownIcon, PlusIcon, UserCircleIcon } from "@heroicons/react/24/solid"
import Personal from './personal'
import Password from './password'

export default function Account() {

    return(
        <>
          <div className="grid grid-cols-2 sm:grid-cols-3 sm:gap-4">
                <Tab.Group>
                    {/* <div className=""> */}
                                <Tab.List className='col-span-full sm:col-auto'>
                                    <Tab as={Fragment} className="mb-2 text-gray-900 lg:col-span-2 sm:p-4 shadow  flex flex-wrap-reverse gap-x-6 rounded-lg p-3 px-2 hover:bg-black hover:text-white">
                                    {({ selected }) => (
                                        <div
                                        className={
                                            selected ? 'w-full bg-black text-white font-semibold ' : 'w-full bg-white text-gray-900 font-medium'
                                        }
                                        >
                                        <span className="text-xs font-light hidden sm:block">Détails sur vos informations personnelles</span>
                                        Informations personnelles
                                        </div>
                                    )}
                                    </Tab>
                                    <Tab as={Fragment} className="mb-2 text-gray-900 lg:col-span-2 sm:p-4 shadow  flex flex-wrap-reverse gap-x-6 rounded-lg p-3 px-2 hover:bg-black hover:text-white">
                                    {({ selected }) => (
                                        <div
                                        className={
                                            selected ? 'w-full bg-black text-white font-semibold ' : 'w-full bg-white text-gray-900 font-medium'
                                        }
                                        >
                                        <span className="text-xs font-light hidden sm:block ">Détails sur votre mot de passe</span>
                                         Mot de passe et sécurité
                                        </div>
                                    )}
                                    </Tab>
                                </Tab.List>
                        
                        {/* <div className="p-4 mb-2 bg-white  rounded-lg 2xl:col-span-2 ">
                            <div className="flow-root">
                                
                            </div>
                        </div> */}
                    {/* </div> */}
            
                    <div className="col-span-2">
                            <Tab.Panels>
                                <Tab.Panel>
                                    <div className="p-4 mb-2 bg-white rounded-lg 2xl:col-span-2  shadow">
                                    <div className="flex justify-between items-center"> 
                                        <div className="flex items-center">
                                        {/* <img src='' alt="user" className="mb-4 rounded-full w-52 h-52 sm:mb-0 lg:mb-4 xl:mb-0"/> */}
                                        <UserCircleIcon className="w-24 h-24 text-gray-500 "/>
                                        <div>
                                            <h2 className="text-base font-semibold leading-7 text-gray-900">Ajouter une nouvelle photo</h2>
                                            <p className="mt-1 text-sm leading-6 text-gray-600">Mettez à jour votre profil.</p>
                                        </div>
                                        </div>
                                        <div className="flex">
                                            <label
                                                htmlFor="file-upload"
                                                className="cursor-pointer flex space-x-2 bg-black text-white rounded-lg py-1.5 px-2.5 shadow-md"
                                                >
                                                <CloudArrowDownIcon className="text-white w-6 h-6"/>
                                                upload
                                                <input id="file-upload" name="file-upload" type="file" className="sr-only" />
                                            </label>
                                        </div>
                                        </div>
                                    </div>
                                    <Personal />
                                </Tab.Panel>
                                <Tab.Panel className="p-4 mb-2 bg-white rounded-lg 2xl:col-span-2  shadow">
                                        <Password/>
                                </Tab.Panel>
                                <Tab.Panel className="p-4 mb-2 bg-white rounded-lg 2xl:col-span-2  shadow">
                                        {/* <DeleteAccount/> */}
                                </Tab.Panel>
                            </Tab.Panels>
                    </div>
                </Tab.Group>
            </div>
      </>
    )
    }